import { PedidoCampoPersonalizadoService } from './../services/pedido-campo-personalizado.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatDialog, PageEvent } from '@angular/material';
import swal from 'sweetalert2';
import { CadastroTabelaPersonalizadaModalComponent } from '../modals/cadastro-tabela-personalizada-modal/cadastro-tabela-personalizada-modal.component';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { ClienteCampoPersonalizadoService } from '../services/cliente-campo-personalizado.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';
import { ProdutoCampoPersonalizadoService } from '../services/produto-campo-personalizado.service';
import { CampoPersonalizadoService } from '../services/campo-personalizado.service';
import { AnaliseDescontoCampoPersonalizadoService } from '../services/analise-desconto-campo-personalizado.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-tabela-personalizada',
  templateUrl: './tabela-personalizada.component.html',
  styleUrls: ['./tabela-personalizada.component.scss']
})
export class TabelaPersonalizadaComponent implements OnInit {

  tabelas = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroDescricao = '';

  tipos = [
    { id: 0, nome: 'Seleção Única' },
    { id: 1, nome: 'Seleção Múltipla' },
    { id: 2, nome: 'Texto' },
  ];

  tabelaAplicacao = [
    { id: 0, nome: 'Integrador' },
    { id: 1, nome: 'Pedido' },
    { id: 2, nome: 'Produtos' },
    { id: 3, nome: 'Análise Desconto - Solicitação' },
    { id: 4, nome: 'Análise Desconto - Conclusão Positiva' },
    { id: 5, nome: 'Análise Desconto - Conclusão Negativa' }
  ];

  tipoAplicacaoSelecionada = 0;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private clienteCampoPersonalizadoService: ClienteCampoPersonalizadoService,
    private pedidoCampoPersonalizadoService: PedidoCampoPersonalizadoService,
    private produtoCampoPersonalizadoService: ProdutoCampoPersonalizadoService,
    private paginatorService: PaginatorService,
    private campoPersonalizadoService: CampoPersonalizadoService,
    private analiseDescontoCampoPersonalizadoService: AnaliseDescontoCampoPersonalizadoService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarTabelasPersonalizadas();
  }

  filtra() {
    this.buscarTabelasPersonalizadas();
    this.paginator.firstPage();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  buscarDescricaoTipo(tipo) {
    return this.tipos.find(p => p.id === tipo).nome;
  }

  buscarDescricaoTipoAplicacao(tipoAplicacao) {
    return this.tabelaAplicacao.find(p => p.id === tipoAplicacao).nome;
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarTabelasPersonalizadas();
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  buscarTabelasPersonalizadas() {
    this.carregandoService.mostra('buscarTabelaPersonalizada');

    this.campoPersonalizadoService.consultarCampoPersonalizadoComPaginacao(
      this.filtroDescricao, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.tipoAplicacaoSelecionada
    ).subscribe(
      (res) => {
        this.tabelas = res.itens;

        this.paginacao.total = res.total;
        this.carregandoService.esconde('buscarTabelaPersonalizada');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTabelaPersonalizada');
        this.notificacaoService.erro(erro);
      }
    );
  }

  novaTabela() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastroTabelaPersonalizadaModalComponent, {
      width: largura > 730 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: {
        editavel: true,
        tipoTabela: this.tipoAplicacaoSelecionada
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarTabelasPersonalizadas();
      }
    });
  }

  editarTabela(tabela) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastroTabelaPersonalizadaModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { tabela, editavel: true },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarTabelasPersonalizadas();
      }
    });
  }

  excluirTabela(id) {
    swal({
      title: 'Deseja realmente Excluir a tabela personalizada?',
      text: '',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
      type: 'warning'
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirTabela');

        let service = null;

        switch (this.tipoAplicacaoSelecionada) {
          case 0:
            service = this.clienteCampoPersonalizadoService;
            break;
          case 1:
            service = this.pedidoCampoPersonalizadoService;
            break;
          case 2:
            service = this.produtoCampoPersonalizadoService;
            break;
          case 3:
          case 4:
          case 5:
            service = this.campoPersonalizadoService;
            break;
        }

        service.excluir(id).subscribe(
          (res) => {
            this.carregandoService.esconde('excluirTabela');
            this.notificacaoService.sucesso('Tabela excluída com sucesso!!!');
            this.buscarTabelasPersonalizadas();
          },
          (erro) => {
            this.carregandoService.esconde('excluirTabela');
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }
}
